<template>
    <div class="col-12 offset-1">
      <div class="card mb-5 me-4" style="margin-top: 4rem; overflow: visible">
        <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
          <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">إضافة رابط جديد</h6>
            </div>
          </div>
        </div>
     
        <div class="card-body px-0 pb-2 pe-3">
          <div class="row justify-content-center">
            <div class="col-12">
              <ChapterSubjectForm 
                ref="chapterSubjectForm"
                title="إضافة رابط جديد"
                submit-text="إضافة الرابط"
                :loading="isSubmitting"
                @submit="handleSubmit" 
                @cancel="handleCancel" 
                @validation-error="handleValidationError"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  import ChapterSubjectForm from '@/components/features/chapter-subject/ChapterSubjectForm.vue';
  import { useToast } from 'vue-toastification';
  import api from '@/api';
  
  const toast = useToast();
  const router = useRouter();
  const chapterSubjectForm = ref(null);
  const isSubmitting = ref(false);
  
  const handleSubmit = async (formData) => {
      try {
          await api.post('/chapter-subjects', formData);
          toast.success("تمت إضافة الرابط بنجاح");
          router.push('/chapter-subjects');
      } catch (error) {
          if (error.response && error.response.status === 422) {
              const errors = error.response.data.errors;
              for (const field in errors) {
                  toast.error(errors[field][0]);
              }
          } else {
              toast.error(error.response?.data?.message || "حدث خطأ أثناء إضافة الرابط");
          }
      }
  };
  
  const handleValidationError = () => {
    toast.warning("الرجاء تعبئة جميع الحقول المطلوبة بشكل صحيح");
  };
  
  const handleCancel = () => {
    if (!isSubmitting.value) {
      router.push('/chapter-subjects');
    }
  };
  </script>